
$(document).ready(function() {
    $('.accordion__toggle').on('click', function(e) {
        e.preventDefault();

        $accordionParentElement = $(this).parent();

        $accordionParentElement.toggleClass('accordion--open');
        $('.accordion__content', $accordionParentElement).slideToggle(300);
    });
});

const shortyAccs = document.querySelectorAll('.shorty-acc__toggle');
shortyAccs.forEach((shortyAcc) => {
    shortyAcc.addEventListener('click', ({ target }) => {
        const accGrp = target.closest('.shorty-acc');
        const accButton = accGrp.querySelector('.shorty-acc__toggle');
        const accContent = accGrp.querySelector('.shorty-acc__content');

        if (accButton.getAttribute('aria-expanded') === 'true') {
            accButton.setAttribute('aria-expanded', false);
            accContent.setAttribute('aria-hidden', true);
        } else {
            accButton.setAttribute('aria-expanded', true);
            accContent.setAttribute('aria-hidden', false);
        }
    });
});

const shortyBook = document.querySelector('.shorty-book');
if (shortyBook) {
    shortyBook.addEventListener('click', (e) => {
        const shortyDates = document.getElementById('course-dates');
        const accGrp = shortyDates.querySelector('.shorty-acc');
        if (accGrp) {
            const accButton = accGrp.querySelector('.shorty-acc__toggle');
            const accContent = accGrp.querySelector('.shorty-acc__content');

            accButton.setAttribute('aria-expanded', true);
            accContent.setAttribute('aria-hidden', false);
        }
    });
}
